// extracted by mini-css-extract-plugin
module.exports = {"subheading":"jargon-buster_subheading__lIm7q","jargonList":"jargon-buster_jargonList__QciKk","container":"jargon-buster_container__7m8o_"};